import classNames from 'classnames'
import Text from 'components/Text'
import Button from 'components/Button'
import ImgStoryblok from 'components/ImgStoryblok'
import './LandingDescription.styl'
import { navigate } from 'gatsby'
import useMediaQuery from 'hooks/useMediaQuery'
import useOriginTheme from 'hooks/useOriginTheme'
import router from 'utils/router'

const LandingDescription = ({ blok, location }) => {
  const isNotMobile = useMediaQuery('desktop')
  const { isRecoveryOrigin } = useOriginTheme()

  const renderItems = () => {
    return blok.descriptions.map((i, index) => (
      <div
        className="description-sub-text"
        key={index}
        aria-label={i?.aria_label}
      >
        <Text
          p
          size={1}
          className="description-sub-text-number"
          aria-hidden="true"
        >
          {i.bold_text}
        </Text>
        <Text
          p
          size={1}
          className="description-sub-text-label"
          aria-hidden="true"
        >
          {i.normal_text}
        </Text>
      </div>
    ))
  }

  const descriptionClassnames = classNames('landing-description-container', {
    'landing-description-container__generalTheme': !isRecoveryOrigin,
  })

  return (
    <div className={descriptionClassnames} id="QuemSomosNos">
      <div className="description-content">
        {isNotMobile && (
          <div className="banner">
            <ImgStoryblok
              src={blok.image.filename}
              alt={blok.image.alt}
              loading="lazy"
            />
          </div>
        )}
        <div className="container-description">
          <Text h2 size={1} className="description-label-text">
            {blok.main_text}
          </Text>
          {!isRecoveryOrigin && (
            <Text p size={1} className="description-main-text">
              {blok.bottom_text}
            </Text>
          )}
          {isRecoveryOrigin && (
            <div
              className="description-banner-itau"
              aria-label="Uma empresa Itaú"
            >
              <Text p aria-hidden="true">
                Uma empresa
              </Text>
              <ImgStoryblok
                src="https://a.storyblok.com/f/119473/x/5d3952a243/itauicon_footer.svg"
                width={31}
                height={42}
                alt="logo Itaú"
                loading="lazy"
                aria-hidden="true"
              />
            </div>
          )}
          {renderItems()}
          {isRecoveryOrigin && (
            <Text p size={1} className="description-main-text">
              {blok.bottom_text}
            </Text>
          )}
          <div className="description-button-container">
            <Button
              className="button"
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.onbeforeunload = null
                }
                navigate('/registro', {
                  state: {
                    source_url: location.href,
                    mp_uuid: router.getQueryString('mp_uuid'),
                  },
                })
              }}
              data-unique="b2f93552-500b-4dd2-a074-4e46dad205e0"
            >
              {blok.button_text}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingDescription
